import * as THREE from 'three'
import Experience from '../Experience.js'
import { ShadowMaterial } from 'three'

// Floor aka Map

export default class Floor {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.resource = this.resources.items.mapModel

        this.setGeometry()
        // this.setTextures()
        // this.setMaterial()
        this.setMesh()
    }

    setGeometry() {
        this.geometry = new THREE.CircleGeometry(5, 64)
    }

    setTextures() {
        this.textures = {}
        this.textures.color = this.resources.items.grassColorTexture
        this.textures.color.colorSpace = THREE.SRGBColorSpace
        this.textures.color.repeat.set(1.5, 1.5)
        this.textures.color.wrapS = THREE.RepeatWrapping
        this.textures.color.wrapT = THREE.RepeatWrapping

        this.textures.normal = this.resources.items.grassNormalTexture
        this.textures.normal.repeat.set(1.5, 1.5)
        this.textures.normal.wrapS = THREE.RepeatWrapping
        this.textures.normal.wrapT = THREE.RepeatWrapping
    }

    setMaterial() {
        this.material = new THREE.MeshStandardMaterial({
            map: this.textures.color,
            normalMap: this.textures.normal
        })
    }

    setMesh() {
        // this.mesh = new THREE.Mesh(this.geometry, this.material)
        // this.mesh.rotation.x = - Math.PI * 0.5
        // this.mesh.receiveShadow = true
        // this.scene.add(this.mesh)

        this.model = this.resource.scene
        this.model.scale.set(1, 1, 1)
        // this.model.position.set(-2.5, -12.1, -1)
        this.scene.add(this.model)

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.receiveShadow = true;
                // child.castShadow = false;

                // Target material names, multiple material per mesh possible
                // if (Array.isArray(child.material)) {
                //     child.material.forEach((mat) => {
                //         if (mat.name === "Land") {
                //             child.material.color.set(0xb1bc7c); // b1bc7c not saturated
                //         } else if (mat.name === "Blank glass") {
                //             child.material.color.set(0xffffff);
                //             child.material.clearcoat = 1.0;
                //             child.material.clearcoatRoughness = 0.2;
                //         }
                //         else if (child.material.name === "Water") {
                //             child.material.color.set(0x3b679e)
                //             child.material.transparent = true
                //             child.material.opacity = 0.9
                //         }
                //     });
                // } else {
                //     if (child.material.name === "Land") {
                //         child.material.color.set(0xb1bc7c); // b1bc7c not saturated
                //     } else if (child.material.name === "Blank glass") {
                //         child.material.color.set(0x00000);
                //         child.material.clearcoat = 1.0;
                //         child.material.clearcoatRoughness = 0.2;
                //     }
                //     else if (child.material.name === "Water") {
                //         child.material.color.set(0x3b679e)
                //         child.material.transparent = true
                //         child.material.opacity = 0.9
                //     }
                // }

                if (child.material.name === "Billboard" || child.material.name === "screen") {
                    child.material = new THREE.MeshBasicMaterial({ map: child.material.map, side: THREE.FrontSide, })
                    child.castShadow = false
                    child.receiveShadow = false
                }

                else if (child.material.name === "Land" || child.material.name === "BakedLand" || child.material.name === "World" || child.material.name === "World2048" || child.material.name === 'World_HD') {
                    child.material = new THREE.MeshStandardMaterial({
                        map: child.material.map,
                        metalness: .5,
                        roughness: 1,
                        side: THREE.FrontSide,

                        // color: 0x00ff00,
                        // transparent: true,
                        // depthWrite: false,
                        // opacity: 1,
                        // side: THREE.DoubleSide,
                        // blending: THREE.NormalBlending,
                    });
                    child.castShadow = true;
                    child.receiveShadow = true;
                    // child.renderOrder = 5;
                }

                else if (child.material.name.includes("invisible")) {
                    child.material = new THREE.MeshBasicMaterial({
                        transparent: true,
                        opacity: 0,
                        depthWrite: false,
                    })
                    child.castShadow = false;
                    child.receiveShadow = false;
                }

                else if (child.material.name === "Indicator") {
                    child.material = new THREE.MeshBasicMaterial({
                        color: 0xffffff,
                    })
                    child.castShadow = false;
                    child.receiveShadow = false;
                }

                else if (child.material.name === 'Slats') {
                    // child.geometry.computeVertexNormals()
                    child.receiveShadow = true
                    child.castShadow = true
                    child.material.color.set(0xffffff)
                }

                // else if (child.material.name === "World") {
                //     child.material = new THREE.MeshStandardMaterial({
                //         // map: child.material.map,
                //         color: 0xffffff,
                //         // transparent: true,
                //         // depthWrite: false,
                //         // opacity: 1,
                //         side: THREE.DoubleSide,
                //         // blending: THREE.NormalBlending,
                //     });
                //     child.castShadow = true;
                //     child.receiveShadow = true;
                // }

                else if (child.material.name === "Blank glass") {
                    // child.material.color.set(0xc9d6ff);
                    child.material.color.set(0x4f7b96);
                    // child.material.color.set(0x000000);
                    child.material.clearcoat = 1.0;
                    child.material.clearcoatRoughness = 0.2;
                }

                // else if (child.material.name === "Water") {
                //     child.material = new THREE.MeshStandardMaterial({
                //         // color: 0x3b679e,
                //         // color: 0x7da8d7,
                //         color: 0xffffff,
                //         transparent: true,
                //         depthWrite: false,
                //         opacity: 0.85,
                //         side: THREE.DoubleSide,
                //         blending: THREE.NormalBlending,
                //     })
                //     child.renderOrder = 2;
                //     // child.depthWrite = false
                //     // child.material.color.set(0x3b679e)
                //     // child.material.transparent = true
                //     // child.material.opacity = 0.8
                //     child.castShadow = true
                //     child.receiveShadow = true
                // }

                // else if (child.material.name === "Town") { // Should be something better, like Building color.
                //     child.receiveShadow = false
                //     child.castShadow = false
                //     child.material.color.set(0xffffff)
                // }

                else if (child.material.name === 'Building_Windows') {
                    child.material = new THREE.MeshBasicMaterial({
                        side: THREE.FrontSide,
                        color: 0x68839a,
                    })

                    // child.renderOrder = 3; // This breaks the branch and fish
                    // child.depthWrite = false
                    child.castShadow = false
                    child.receiveShadow = false
                }

                // Target mesh names
                if (child.name === "Floor") {
                    child.material = new THREE.MeshBasicMaterial({ map: child.material.map })
                }

                if (child.name.includes("Location_") && !child.name.includes("Spawn") && !child.name.includes("Target")) {
                    child.material.visible = false;
                }

                if (child.name === "Bottle") {
                    child.material = new THREE.MeshLambertMaterial({
                        side: THREE.FrontSide,
                        // color: 0x60c4ff,
                        color: 0x68839a,
                        transparent: true,
                        opacity: 0.25,
                        // blending: THREE.NormalBlending,
                    })

                    // child.renderOrder = 3; // This breaks the branch and fish
                    // child.depthWrite = false
                    child.castShadow = false
                    child.receiveShadow = false
                    child.renderOrder = 0
                }

                if (child.name === "Label") {
                    child.material = new THREE.MeshBasicMaterial({ map: child.material.map, transparent: true, opacity: 1, side: THREE.FrontSide })
                    child.renderOrder = 2
                }

                if (child.name === 'Land') {
                    // child.material = new THREE.MeshBasicMaterial({ map: child.material.map, side: THREE.FrontSide })
                    // // child.material.side = THREE.DoubleSide;
                    // child.castShadow = false
                    // child.receiveShadow = false
                    child.material = new THREE.MeshStandardMaterial({
                        map: child.material.map,
                        metalness: .5,
                        roughness: 1,
                        side: THREE.FrontSide,

                        // color: 0x00ff00,
                        // transparent: true,
                        // depthWrite: false,
                        // opacity: 1,
                        // side: THREE.DoubleSide,
                        // blending: THREE.NormalBlending,
                    });
                    child.castShadow = true;
                    child.receiveShadow = true;
                }

                // if (child.name === 'Land_Bottom_Split') {
                //     child.material = new THREE.MeshStandardMaterial({ map: child.material.map, roughness: 0.8, metalness: 0 })
                //     // child.material.side = THREE.DoubleSide;
                //     child.castShadow = false
                //     child.receiveShadow = false
                // }



                if (child.name.includes("Inner") || child.name.includes("Outer")) {
                    child.material = new THREE.MeshBasicMaterial({ map: child.material.map });
                    // child.material.color.set(0xffffff)
                    // child.material.transparent = true
                    // child.material.opacity = 0.9
                    // child.material = new THREE.MeshBasicMaterial()
                    child.material.side = THREE.DoubleSide;
                    child.castShadow = false
                    child.receiveShadow = false
                }

                if (child.name === 'Water') {
                    // child.material.side = THREE.DoubleSide

                    // child.material = new THREE.MeshPhysicalMaterial({
                    //     side: THREE.DoubleSide,
                    //     color: 0xfff,
                    //     transparent: true,
                    //     opacity: 0.7,
                    //     // blending: THREE.NormalBlending,
                    // })

                    child.material = new THREE.MeshLambertMaterial({
                        side: THREE.DoubleSide,
                        // color: 0x60c4ff,
                        // color: 0x68839a,
                        color: 0x7194bd,
                        transparent: true,
                        opacity: 0.9,
                        // blending: THREE.NormalBlending,
                    })

                    child.renderOrder = 3; // This breaks the branch and fish
                    // child.depthWrite = false
                    child.castShadow = false
                    child.receiveShadow = false


                    // child.material.color = "0x0270cd"
                    // child.material.transparent = true
                    // child.material.opacity = 0.9
                }

                if (child.name.includes("branch")) {
                    // child.geometry.computeVertexNormals()
                    // child.material = new THREE.MeshStandardMaterial({
                    //     map: child.material.map,
                    //     // color: 0xffffff,
                    //     transparent: true,
                    //     depthWrite: false,
                    //     opacity: 1,
                    //     side: THREE.DoubleSide,
                    //     blending: THREE.NormalBlending,
                    // });
                    // child.renderOrder = 3;
                    // child.material.depthWrite = false;
                    child.castShadow = true;
                    child.receiveShadow = true;
                }


                if (child.name.includes("Underwaterplant")) {
                    // child.material.dispose();
                    // child.material = new THREE.MeshStandardMaterial({})
                    child.castShadow = true;
                    child.receiveShadow = true;
                }


                if (child.name === 'Windows' || child.name === 'Interior_building_windows') {
                    child.geometry.computeVertexNormals()
                    // child.receiveShadow = false
                    // child.castShadow = false
                    child.renderOrder = 1;
                    child.material.depthWrite = false;


                    // child.material.blending = THREE.NormalBlending
                    child.material.transparent = true
                    // child.material.opacity = 0.8

                    // child.material = new THREE.MeshPhysicalMaterial({
                    //     color: 0x88ccff,
                    //     metalness: 0.1,
                    //     roughness: 0.4,
                    //     transmission: 0.25,
                    //     thickness: 0.05, // refraction

                    //     color: 0x88ccff,            // Light blue tint
                    //     // metalness: 0.1,             // Low metalness for subtle reflections
                    //     // roughness: 1,             // Higher roughness for frosted look
                    //     // transmission: 0.2,          // High transmission for transparency
                    //     // transparent: true,          // Enable transparency
                    //     side: THREE.DoubleSide,
                    //     opacity: .9,               // Adjust opacity for effect
                    //     clearcoat: 1.0,             // Add a clear coat for extra realism
                    //     clearcoatRoughness: 0.2,    // Slight roughness for the clear coat
                    //     envMap: this.environmentMap,     // Environment map for realistic reflections
                    //     envMapIntensity: 1.0,       // Intensity of environment map reflections
                    //     ior: 1.5,
                    // })

                    // Better looking reflective material
                    child.material = new THREE.MeshPhysicalMaterial({
                        color: 0x88ccff,            // Light blue tint
                        metalness: 0.1,             // Low metalness for subtle reflections
                        roughness: 1,             // Higher roughness for frosted look
                        transmission: 0.2,          // High transmission for transparency
                        transparent: true,          // Enable transparency
                        // side: THREE.DoubleSide,
                        opacity: .9,
                        // depthWrite: true,
                        // alphaTest: 0.5,         // Adjust opacity for effect
                        clearcoat: 1.0,             // Add a clear coat for extra realism
                        clearcoatRoughness: 0.2,    // Slight roughness for the clear coat
                        // envMap: this.environmentMap,     // Environment map for realistic reflections
                        envMapIntensity: 1.0,       // Intensity of environment map reflections
                        ior: 1.5,
                    });
                    // child.material.side = THREE.DoubleSide
                    // child.material.transparent = true
                    // child.material.opacity = 0.2
                }
                if (child.name === 'Edge' || child.name === 'Ceiling' || child.name === 'Outer_walls') {
                    child.geometry.computeVertexNormals()
                    child.receiveShadow = true
                    child.castShadow = true
                    // child.material.side = THREE.DoubleSide
                    // child.material.color.set(0xb1bc7c)
                    child.material.color.set(0xffffff)

                    // child.material.dispose();
                    // child.material = new THREE.MeshStandardMaterial({
                    //     color: 0xffffff,
                    // });

                    // child.material.needsUpdate = true;
                    // child.geometry.attributes.position.needsUpdate = true;

                    // child.onBeforeCompile = () => {
                    //     child.material.needsUpdate = true;
                    // };
                }

                // if (child.name.includes("Turbine")) {
                //     child.geometry.computeVertexNormals()
                //     child.receiveShadow = true
                //     child.castShadow = true;

                //     child.material = new THREE.MeshStandardMaterial({
                //         color: 0xffffff,
                //     })
                // }
            }
        })
    }
}